// extracted by mini-css-extract-plugin
export default {"sidebar":"SidebarSmall_sidebar__-0dse","sidebarActive":"SidebarSmall_sidebarActive__Xh+Sj","showArrow":"SidebarSmall_showArrow__evn9l"};